import { createReducer, on } from "@ngrx/store";
import { StateTypes } from "../../../models/state-types";
import { loadCurvesActions } from "../load_curves.actions";
import { CounterOutput } from "../../../models/load_curves.model";

export interface CounterState {
    counters: CounterOutput[]|null,
    counters_state: StateTypes

    single_counter: CounterOutput|null,
    single_counter_state: StateTypes
}

export const initialState: CounterState = {
    counters: null,
    counters_state: 'pending',

    single_counter: null,
    single_counter_state: 'pending'
};

export const counterReducer = createReducer(
    initialState,

    on(loadCurvesActions.getCounters, (state) => ({
        ...state,
        counters: null,
        counters_state: 'loading' as const
    })),
    on(loadCurvesActions.getCountersSuccess, (state, {data}) => ({
        ...state,
        counters: data,
        counters_state: 'loaded' as const
    })),
    on(loadCurvesActions.getCountersFail, (state) => ({
        ...state,
        counters: null,
        counters_state: 'error' as const
    })),


    on(loadCurvesActions.getSingleCounter, (state) => ({
        ...state,
        single_counter: null,
        single_counter_state: 'loading' as const
    })),
    on(loadCurvesActions.getSingleCounterSuccess, (state, {data}) => ({
        ...state,
        single_counter: data,
        single_counter_state: 'loaded' as const
    })),
    on(loadCurvesActions.getSingleCounterFail, (state) => ({
        ...state,
        single_counter: null,
        single_counter_state: 'error' as const
    }))
)